(() => {
  if (window.phLandingEditableReady) return;
  window.phLandingEditableReady = true;

  const initialize = () => {
    document.querySelectorAll('.hero-videos:not([data-ph-ready])').forEach((carousel) => {
      carousel.dataset.phReady = 'true';
      const track = carousel.querySelector('.video-track');
      const next = carousel.querySelector('.video-next');
      if (!track || !next) return;
      next.addEventListener('click', () => {
        const card = track.querySelector('.video-frame');
        track.scrollBy({ left: (card?.offsetWidth || 300) + 16, behavior: 'smooth' });
      });
    });

    document.querySelectorAll('.offer-countdown[data-deadline]:not([data-ph-ready])').forEach((timer) => {
      timer.dataset.phReady = 'true';
      const deadline = Date.parse(timer.dataset.deadline);
      if (!Number.isFinite(deadline)) return;
      const render = () => {
        let remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        const days = Math.floor(remaining / 86400);
        remaining %= 86400;
        const hours = Math.floor(remaining / 3600);
        remaining %= 3600;
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;
        const values = { days, hours, minutes, seconds };
        Object.entries(values).forEach(([id, value]) => {
          const target = timer.querySelector(`#${id}`);
          if (target) target.textContent = String(value).padStart(2, '0');
        });
      };
      render();
      window.setInterval(render, 1000);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
